import { render, staticRenderFns } from "./VirtualProviderApplications.vue?vue&type=template&id=1bc7746f&"
import script from "./VirtualProviderApplications.vue?vue&type=script&lang=js&"
export * from "./VirtualProviderApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports